<vs-form-field
  [config]="{ label: (displayLabel || property.name) + (required ? '' : ' (optional)') + ':' }"
  appearance="vertical"
>
  <span *ngIf="helpText" slot="hint" class="text-gray-600 text-sm">{{ helpText }}</span>
  <vs-input-container>
    <vs-number-input
      class="w-full"
      #input
      [property]="property"
      [formControl]="formControl"
      [required]="required"
      [showErrors]="false"
      (touched)="markAsTouched()"
    ></vs-number-input>
  </vs-input-container>

  <span class="text-danger" slot="hint" *ngIf="input.control.touched && input.control.hasError('required')">
    {{ displayLabel || property.name }} must have a value
  </span>

  <span class="text-danger" slot="hint" *ngIf="input.control.touched && input.control.hasError('min')">
    {{ displayLabel || property.name }} must be {{ input.formatValue(property.config.min) }} or greater
  </span>

  <span class="text-danger" slot="hint" *ngIf="input.control.touched && input.control.hasError('max')">
    {{ displayLabel || property.name }} must be {{ input.formatValue(property.config.max) }} or less
  </span>

  <span class="text-danger" slot="hint" *ngIf="input.control.touched && input.control.hasError('step')">
    {{ displayLabel || property.name }} must use increments of {{ input.formatValue(property.config.step) }} starting
    from
    {{ input.formatValue(property.config.min ?? 0) }}
  </span>

  <span class="text-danger" slot="hint" *ngIf="input.control.touched && input.control.hasError('number')">
    {{ displayLabel || property.name }} must be a valid number
  </span>

  <span class="text-danger" slot="hint" *ngIf="input.control.touched && input.control.hasError('allowedValues')">
    {{ displayLabel || property.name }} must be one of {{ input.allowedValueLabels }}
  </span>
</vs-form-field>
